import { render } from "./WatchList.vue?vue&type=template&id=4dd57208&scoped=true"
import script from "./WatchList.vue?vue&type=script&lang=js"
export * from "./WatchList.vue?vue&type=script&lang=js"

import "./WatchList.vue?vue&type=style&index=0&id=4dd57208&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bp-kmiyajima\\Documents\\Projects\\noritz-portal\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd57208"]])

export default __exports__